import React from 'react';
import {useIntl} from 'react-intl';
import {
  usePirBoxPageLogic,
  walletPageMessages,
  selectHasTotalFia,
  selectHasRealEconomy,
  selectHasBperProduct,
  walletCategoryMessages,
} from 'azshared';
import { useSelector } from 'react-redux';
import './pir-box-disclaimer-financial-position.scss';

interface PirBoxDisclaimerFinancialPositionProps {
  sectionMode: string;
}

export const PirBoxDisclaimerFinancialPosition = (props: PirBoxDisclaimerFinancialPositionProps) => {
  const { hasAlternative, hasOrdinary } = usePirBoxPageLogic();
  const { formatMessage } = useIntl();
  const hasTotalFia = useSelector(selectHasTotalFia);
  const hasRealEconomy = useSelector(selectHasRealEconomy);
  const hasBperProduct = useSelector(selectHasBperProduct);
  const { sectionMode } = props;
  return (
    <div className='real-economy-explain'>
      {((hasRealEconomy && hasAlternative) && sectionMode) === 'MY_WALLET' && <p>{formatMessage(walletPageMessages.walletAlternativePirBoxPositionList)}</p>}
      {((hasRealEconomy && hasOrdinary) && sectionMode) === 'MY_WALLET' && (
        <p>
          {hasAlternative ? '****' : ''}
          {formatMessage(walletPageMessages.walletOrdinaryPirBoxPositionList)}
        </p>
      )}
      {hasTotalFia && hasRealEconomy && <p>{formatMessage(walletPageMessages.walletTotalFiaNote)}</p>}
      {hasBperProduct && <p>**** {formatMessage(walletCategoryMessages.bperNote)}</p>}
    </div>
  );
};
